<template>
  <div class="realname-page">
    <div class="mobile-frame">
      <header class="topbar">
        <i class="el-icon-arrow-left"></i>
        <span>账户更名</span>
        <i class="el-icon-more"></i>
      </header>

      <h1 class="page-title">更新姓名或证件号码</h1>

      <section class="identity-card">
        <div class="identity-head">
          <span>当前认证身份:</span>
          <button class="view-btn" type="button" @click="toggleSensitive">
            <i class="el-icon-view" :class="{ hidden: !showSensitive }"></i>
          </button>
        </div>
        <div class="identity-row">
          <span>姓名:</span>
          <span>{{ displayName }}</span>
        </div>
        <div class="identity-row">
          <span>证件号码:</span>
          <span>{{ displayIdCard }}</span>
        </div>
        <div v-if="showSensitive" class="identity-row">
          <span>证件类型:</span>
          <span>{{ userInfo.idType }}</span>
        </div>
        <div v-if="showSensitive" class="identity-row">
          <span>国家/地区:</span>
          <span>{{ userInfo.region }}</span>
        </div>
      </section>

      <h2 class="section-title">请根据实际情况，选择对应方案</h2>

      <section class="option-list">
        <div class="option-item clickable" @click="goUpdateIdImage">
          <span>我在公安局变更了姓名或证件号</span>
          <div class="option-action">
            <span class="link-text">去更新</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="option-item">
          <span>已认证身份不是自己，无法变更</span>
          <div class="option-action">
            <span class="link-text">查看原因</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlipayRealname",
  data() {
    return {
      showSensitive: true,
      userInfo: {
        name: "贾诗琪",
        idCard: "431302200211030063",
        idType: "身份证",
        region: "中国大陆",
      },
    };
  },
  computed: {
    displayName() {
      if (this.showSensitive) return this.userInfo.name;
      const name = this.userInfo.name || "";
      if (name.length <= 1) return "*";
      return `${"*".repeat(name.length - 1)}${name.slice(-1)}`;
    },
    displayIdCard() {
      if (this.showSensitive) return this.userInfo.idCard;
      const idCard = this.userInfo.idCard || "";
      if (idCard.length <= 2) return `${idCard}*`;
      return `${idCard.slice(0, 1)}${"*".repeat(idCard.length - 2)}${idCard.slice(-1)}`;
    },
  },
  methods: {
    toggleSensitive() {
      this.showSensitive = !this.showSensitive;
    },
    goUpdateIdImage() {
      this.$router.push({ name: "AlipayIdImageUpdate" });
    },
  },
};
</script>

<style scoped>
.realname-page {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
}

.mobile-frame {
  width: 100%;
  max-width: 430px;
  padding: 10px 16px 24px;
  box-sizing: border-box;
}

.topbar {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #232323;
  font-size: 20px;
}

.topbar span {
  font-size: 24px;
  font-weight: 700;
  color: #1f1f1f;
}

.page-title {
  margin: 30px 0 28px;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  color: #1e1e1e;
}

.identity-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px 12px;
}

.identity-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #4f4f4f;
  font-size: 18px;
  margin-bottom: 6px;
}

.view-btn {
  border: none;
  background: transparent;
  padding: 0;
  line-height: 1;
  cursor: pointer;
}

.identity-head i {
  color: #3f9dff;
  font-size: 20px;
  position: relative;
}

.identity-head i.hidden::after {
  content: "";
  position: absolute;
  left: -1px;
  right: -1px;
  top: 50%;
  border-top: 1.5px solid #3f9dff;
  transform: rotate(-18deg);
}

.identity-row {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 17px;
  color: #8a8a8a;
}

.identity-row span:last-child {
  color: #6a6a6a;
}

.section-title {
  margin: 20px 0 12px;
  font-size: 20px;
  color: #262626;
  font-weight: 700;
  text-align: left;
}

.option-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.option-item {
  background: #fff;
  border-radius: 12px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  gap: 6px;
  align-items: center;
}

.option-item.clickable {
  cursor: pointer;
}

.option-item > span {
  font-size: clamp(12px, 3.9vw, 18px);
  color: #333;
  line-height: 1.4;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  text-align: left;
}

.option-action {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
}

.link-text {
  color: #268fdf;
  font-size: clamp(12px, 3.8vw, 18px);
}

.option-action i {
  color: #b8b8b8;
  font-size: 16px;
}

@media (min-width: 768px) {
  .mobile-frame {
    max-width: 430px;
  }
}
</style>
